import { AgGridReact } from "ag-grid-react";
import "ag-grid-enterprise";
import React, { createContext, useContext, useEffect, useRef } from "react";

import MonthlyPerformanceStore from "./store/monthlyperformancestore";
import { observer } from "mobx-react-lite";
import { Button, Empty, message, notification, Skeleton, Tooltip } from "antd";
import {
  ConsoleSqlOutlined,
  DeleteOutlined,
  ExclamationCircleOutlined,
  FileExcelOutlined,
  LockTwoTone,
  UploadOutlined,
  ZoomInOutlined,
} from "@ant-design/icons";
import { NoData } from "../../shared/NoData";
import moment from "moment";
import formatNumber from "accounting-js/lib/formatNumber.js";
import "./styles/monthlyPerformance.css";
import {
  CommandBar,
  MessageBar,
  MessageBarType,
  SearchBox,
} from "@fluentui/react";

import {
  RefreshCcw,
  Edit3,
  Trash2,
  ZoomIn,
  Type,
  UploadCloud,
  Lock,
  Unlock,
  FileText,
  ShieldOff,
} from "react-feather";
import { toJS } from "mobx";
import confirm from "antd/lib/modal/confirm";
import { FilterCallOut } from "../../shared/FilterCallOut";
import ReportStore from "../../shared/ReportStore";

const _ = require("underscore");
const MonthlyPerformanceStoreCtx = createContext(MonthlyPerformanceStore);
const reportStoreCtx = createContext(ReportStore);
export const MonthlyProductionGrid = observer((props) => {
  const monthlyPerformanceStore = useContext(MonthlyPerformanceStoreCtx);
  const reportStore = useContext(reportStoreCtx);
  const monthProdGrid = useRef(null);

  useEffect(() => {
    async function loadproductionHistory() {
      try {
        await monthlyPerformanceStore.loadProductions();
        monthlyPerformanceStore.resultFromQuery = false;
      } catch (error) {
        notification.error({
          message: "SPARS Feedback",
          description: error.message,
        });
      }
    }
    loadproductionHistory();
  }, []);

  const formatDigit = (params) => {
    const { value } = params;
    // this puts commas into the number eg 1000 goes to 1,000,
    // i pulled this from stack overflow, i have no idea how it works
    if (value) {
      return formatNumber(value, {
        precision: 0,
        thousand: ",",
      });
    }
  };
  const sortChanged = (e) => {
    e.api.refreshCells();
  };
  const gridcolumnDefs = {
    columnDefs: [
      {
        headerName: "#",
        valueGetter: "node.rowIndex + 1",
        width: 40,
        resizable: true,
        sortable: true,
        pivot: false,
      },
      {
        width: 30,
        checkboxSelection: true,
        pivot: false,
        resizable: true,
      },
      {
        headerName: "Production Year",
        field: "prodYear",
        sortable: true,
        resizable: true,
        pivot: true,
        hide: true,
        width: 80,
      },
      {
        headerName: "Month",
        field: "prodMonth",
        sortable: true,
        resizable: true,
        pivot: true,

        hide: true,
        width: 80,
      },
      {
        headerName: "Production Month",
        field: "monthName",
        sortable: true,
        resizable: true,
        hide: true,
        width: 100,
      },
      {
        headerName: "HIERARCHY",

        children: [
          {
            headerName: "UNIQUE ID",
            field: "uniqueId",
            sortable: true,
            resizable: true,

            filter: true,
            width: 120,
          },
          {
            headerName: "FLOWSTATION",
            field: "flowstation",
            sortable: true,
            resizable: true,

            filter: true,
            width: 125,
          },
          {
            headerName: "FIELD",
            field: "field",
            sortable: true,
            resizable: true,

            filter: true,
            width: 120,
          },
          {
            headerName: "WELL",
            field: "well",
            sortable: true,
            resizable: true,
            filter: true,
            width: 100,
          },
          {
            headerName: "LEVEL",
            field: "level",
            filter: true,
            sortable: true,
            resizable: true,
            width: 80,
          },
        ],
      },
      {
        headerName: "Producing Days (Days On)",
        field: "days",
        sortable: true,
        resizable: true,
        width: 80,
        cellRendererFramework: function (props) {
          if (!props.data?.days) return 0;

          return props.data.days;
        },
      },
      {
        headerName: "Month Produced",
        field: "numMonthProduced",
        sortable: true,
        resizable: true,
        width: 80,
        type: "numberColumn",
      },

      {
        headerName: 'CHOKE (1/64)"',
        field: "choke",
        filter: true,
        width: 80,
        sortable: true,
        resizable: true,
      },

      {
        headerName: "FTHP",
        field: "fthp",
        sortable: true,
        resizable: true,
        width: 120,
      },

      {
        headerName: "BSW",
        field: "bsw",
        sortable: true,
        resizable: true,

        width: 150,
      },

      {
        headerName: "API",
        field: "api",
        sortable: true,
        resizable: true,

        width: 150,
      },
      {
        headerName: "  GOR ",

        children: [
          {
            headerName: "Initial",

            field: "initialGOR",
            sortable: true,
            resizable: true,

            width: 100,
            type: "numberColumn",
            valueFormatter: formatDigit,
          },

          {
            headerName: "Producing",

            field: "producingGOR",
            sortable: true,
            resizable: true,

            width: 100,
            type: "numberColumn",
            valueFormatter: formatDigit,
          },
        ],
      },

      {
        headerName: "TYPE",
        field: "type",
        sortable: true,
        resizable: true,

        width: 80,
      },
      {
        headerName: "DATE LAST PRODUCTION.",
        field: "dateLastProduced",
        sortable: true,
        resizable: true,
        width: 120,
        cellRendererFramework: function (props) {
          if (!props.data?.dateLastProduced) return "";

          return moment(props.data.dateLastProduced).format("D-MMM-YY");
        },
        pinnedRowCellRenderer: (props) => {
          return "Sum Total";
        },
      },
      {
        headerName: "PRODUCTION RATES",
        children: [
          {
            headerName: "OIL (stb/d)",
            field: "oilRate",
            cellStyle: { textAlign: "center", backgroundColor: "#E2E9EB" },

            width: 100,
            sortable: true,
            resizable: true,

            type: "numberColumn",
            valueFormatter: formatDigit,
            headerTooltip: "OIL (stb/d)  calculated by SPARS",
          },
          {
            headerName: "GAS (Mscf/d)",
            field: "gasRate",
            sortable: true,
            resizable: true,
            cellStyle: {
              textAlign: "right",
              backgroundColor: "#E2E9EB",
            },
            width: 100,
            type: "numberColumn",
            valueFormatter: formatDigit,
            headerTooltip: "GAS (Mscf/d)  calculated by SPARS",
          },
        ],
      },
      {
        headerName: "MONTHLY PRODUCTIONS",

        children: [
          {
            headerName: "OIL (stb)",
            field: "oil",
            cellStyle: { textAlign: "center", backgroundColor: "#ffcdd2" },

            width: 100,
            sortable: true,
            resizable: true,

            type: "numberColumn",
            valueFormatter: formatDigit,
            /*  pinnedRowCellRendererParams: {
              style: { color: "red" },
            },
            pinnedRowCellRenderer: (props) => {
              return monthlyPerformanceStore.totalOil;
            }, */
          },
          {
            headerName: "GAS (Mscf)",
            field: "gas",
            sortable: true,
            resizable: true,
            cellStyle: {
              textAlign: "right",
              backgroundColor: "#C8E6C9",
            },
            width: 100,
            type: "numberColumn",
            valueFormatter: formatDigit,
          },
          {
            headerName: "WATER (stb)",

            field: "water",
            sortable: true,
            resizable: true,
            cellStyle: {
              textAlign: "right",
              backgroundColor: "#FFECB3",
            },
            width: 100,
            type: "numberColumn",
            valueFormatter: formatDigit,
          },
        ],
      },
      {
        headerName: "CUMMULATIVE PRODUCTIONS",
        children: [
          {
            headerName: "Oil Cummulatives (stb)",

            field: "cumOil",
            sortable: true,
            resizable: true,
            cellStyle: {
              textAlign: "right",
              backgroundColor: "#E2E9EB",
            },
            width: 100,
            type: "numberColumn",
            valueFormatter: formatDigit,
            headerTooltip: "Oil Cummulatives (stb)  calculated by SPARS",
          },

          {
            headerName: "Gas Cummulatives (Mscf)",

            field: "cumGas",
            sortable: true,
            resizable: true,
            cellStyle: {
              textAlign: "right",
              backgroundColor: "#E2E9EB",
            },
            width: 100,
            type: "numberColumn",
            valueFormatter: formatDigit,
            headerTooltip: "Gas Cummulatives (Mscf)  calculated by SPARS",
          },
          {
            headerName: "Cummulative Water Prod. (stb)",

            field: "cumWater",
            sortable: true,
            resizable: true,
            cellStyle: {
              textAlign: "right",
              backgroundColor: "#E2E9EB",
            },
            width: 100,
            type: "numberColumn",
            valueFormatter: formatDigit,
            headerTooltip: "Cummulative Water Prod. (stb)  calculated by SPARS",
          },
        ],
      },
      {
        headerName: "FLOWSTATION STATUS",
        field: "flowstationStatus",
        sortable: true,
        resizable: true,

        filter: true,
        width: 120,
      },
      {
        headerName: "FIELD STATUS",
        field: "fieldStatus",
        sortable: true,
        resizable: true,

        filter: true,
        width: 120,
      },
      {
        headerName: "REMARKS",
        field: "remarks",
        sortable: true,
        resizable: true,

        width: 150,
      },
      {
        headerName: "AUDIT",

        children: [
          {
            headerName: "Uploaded(Modified) By",
            field: "uploadedBy",
            filter: true,
            sortable: true,
            resizable: true,
          },
          {
            headerName: "Uploaded On",
            field: "uploadedOn",
            sortable: true,
            resizable: true,
            filter: true,
            cellRendererFramework: function (props) {
              return moment(props.data.uploadedOn).format(
                "ddd DD.MM.YYYY , h:mm:ss a"
              );
            },
          },
        ],
      },
    ],
  };
  const getTotal = (col) => {
    const data = _.pluck(
      [...monthlyPerformanceStore.prodHistory.values()].map((d) => toJS(d)),
      col
    );

    const sum = _.reduce(
      data,
      function (memo, num) {
        return (
          Number(memo) + Number(_.isNull(num) || _.isUndefined(num) ? 0 : num)
        );
      },
      0
    );

    return sum;
  };
  const rowSelected = (grid) => {
    monthlyPerformanceStore.disableCommand = false;
    const selrow = grid.api.getSelectedNodes()[0];
    if (selrow) {
      monthlyPerformanceStore.selRow = toJS(selrow.data);
      console.log(toJS(selrow.data));
    }
  };
  const refreshData = async () => {
    try {
      let queryCriteria = {
        startDate: moment(new Date())
          .startOf("month")
          .format("YYYY-MM-DDT00:00:00.000Z"),
        endDate: moment(new Date())
          .endOf("month")
          .format("YYYY-MM-DDT00:00:00.000Z"),
        fromInception: false,
        specificDate: true,
      };

      monthlyPerformanceStore.queryCriteria = queryCriteria;
      await monthlyPerformanceStore.loadProductions();
      monthlyPerformanceStore.gridHeaderText = `NAOC MONTHLY PRODUCTIONS for ${moment(
        queryCriteria.startDate
      ).format("MMM-YYYY")}`;
      monthlyPerformanceStore.resultFromQuery = false;
    } catch (error) {
      notification.error({
        message: "SPARS Feedback",
        description: error.message,
      });
    }
  };
  const refreshHandler = async () => {
    await refreshData();
  };
  return (
    <>
      <div className="ms-Grid-row">
        <div className="ms-Grid-col ms-sm12">
          <CommandBar
            items={[
              {
                key: "filtert1",
                onRenderIcon: () => <FilterCallOut />,
              },
              {
                key: "refresh",
                text: (
                  <Tooltip title="Refresh daily production data">
                    Refresh
                  </Tooltip>
                ),

                onRenderIcon: () => <RefreshCcw className="qicon" />,

                onClick: async () => {
                  await refreshData();
                },
              },
              {
                key: "modify",
                text: (
                  <Tooltip title="Modify or edit selected daily production figures">
                    Re-Upload
                  </Tooltip>
                ),

                onRenderIcon: () => <Edit3 className="qicon" />,
                disabled:
                  monthlyPerformanceStore.prodHistory.size === 0 ||
                  monthlyPerformanceStore.lockData ||
                  monthlyPerformanceStore.disableCommand,
                onClick: async () => {
                  if (monthlyPerformanceStore.selRow) {
                    confirm({
                      title: `Confirm re-upload of ${moment(
                        monthlyPerformanceStore.queryCriteria.startDate
                      ).format("MMM-YYYY")} Monthly Productions?`,
                      content: (
                        <span style={{ color: "red" }}>
                          This data re-upload operation will be logged
                        </span>
                      ),
                      okText: "Yes",
                      okType: "danger",
                      cancelText: "No",
                      onOk: () => {
                        try {
                          monthlyPerformanceStore.initFormaData =
                            monthlyPerformanceStore.selRow;

                          monthlyPerformanceStore.uploadDate = moment(
                            monthlyPerformanceStore.queryCriteria.startDate
                          );
                          monthlyPerformanceStore.showNaocMonthlyProductionDialog = true;
                          monthlyPerformanceStore.reupload = true;
                        } catch (error) {
                          notification.info({
                            message: "SPARS Feedback",
                            description:
                              "an error occured during the operation",
                          });
                        }
                      },
                      onCancel() {},
                    });
                  }
                },
              },

              {
                key: "remove",
                text: (
                  <Tooltip title="Remove or delete selected daily production data with action logged ">
                    Remove
                  </Tooltip>
                ),
                name: "delete",
                disabled:
                  monthlyPerformanceStore.lockData ||
                  monthlyPerformanceStore.disableCommand ||
                  monthlyPerformanceStore.disableDelete,
                // disabled: accountStore.userCommandBarDisabled,

                onRenderIcon: () => <Trash2 className="qicon" />,
                onClick: () => {
                  confirm({
                    icon: <DeleteOutlined />,
                    title: "Delete Production Data",
                    content: (
                      <div
                        className="ms-Grid"
                        dir="ltr"
                        style={{ padding: "10px" }}
                      >
                        <div className="ms-Grid-row">
                          <div className="ms-Grid-col ms-sm12">
                            {`Confirm delete of  ${moment(
                              monthlyPerformanceStore.queryCriteria.startDate
                            ).format("MMM-YYYY")} production data `}
                          </div>
                        </div>
                        <div className="ms-Grid-row">
                          <div
                            className="ms-Grid-col ms-sm12"
                            style={{ fontStyle: "italic", padding: "10px" }}
                          >
                            <ExclamationCircleOutlined
                              style={{ color: "red" }}
                            />{" "}
                            this operation will be logged
                          </div>
                        </div>
                      </div>
                    ),
                    onOk: async () => {
                      try {
                        const lockDate = moment(
                          monthlyPerformanceStore.queryCriteria.startDate
                        );
                        console.log(lockDate.toDate());
                        if (lockDate.isValid()) {
                          const retVal =
                            await monthlyPerformanceStore.deleteProduction();

                          if (retVal.success) {
                            message.success(
                              `${moment(
                                monthlyPerformanceStore.queryCriteria.startDate
                              ).format(
                                "MMM-YYYY"
                              )} Production records removed successfully`
                            );
                            monthlyPerformanceStore.disableDelete = true;
                            await monthlyPerformanceStore.loadProductions();
                          } else {
                            message.error(
                              `${moment(
                                monthlyPerformanceStore.queryCriteria.startDate
                              ).format(
                                "MMM-YYYY"
                              )} Production records removal failed`
                            );
                          }
                        } else {
                          message.info("select a valid production month");
                        }
                      } catch (error) {
                        notification.error({
                          message: "SPARS Feedback",
                          description: error.response && error.response.text,
                        });
                      }
                    },
                    onCancel() {
                      console.log("Cancel");
                    },
                  });
                },
              },
              {
                key: "lock",
                text: (
                  <Tooltip title="Lock-in production data to prevent productions data modifications and turns productions data to readOnly mode">
                    Lock-In Production
                  </Tooltip>
                ),
                name: "delete",
                disabled:
                  monthlyPerformanceStore.lockData ||
                  monthlyPerformanceStore.disableCommand,

                onRenderIcon: () => <Lock className="qicon" />,
                onClick: () => {
                  confirm({
                    icon: <LockTwoTone />,
                    title: "Lock-In Production Data",
                    content: (
                      <div
                        className="ms-Grid"
                        dir="ltr"
                        style={{ padding: "10px" }}
                      >
                        <div className="ms-Grid-row">
                          <div className="ms-Grid-col ms-sm12">
                            {`Confirm lock of  ${moment(
                              monthlyPerformanceStore.queryCriteria.startDate
                            ).format("MMM-YYYY")} production data `}
                          </div>
                        </div>
                        <div className="ms-Grid-row">
                          <div
                            className="ms-Grid-col ms-sm12"
                            style={{ fontStyle: "italic", padding: "10px" }}
                          >
                            <ExclamationCircleOutlined
                              style={{ color: "red" }}
                            />{" "}
                            this operation will be logged
                          </div>
                        </div>
                      </div>
                    ),
                    onOk: async () => {
                      try {
                        const lockDate = moment(
                          monthlyPerformanceStore.queryCriteria.startDate
                        );
                        console.log(lockDate.toDate());
                        if (lockDate.isValid()) {
                          const retVal =
                            await monthlyPerformanceStore.lockProduction(true);

                          monthlyPerformanceStore.lockData =
                            retVal.dataLockStatus;
                          monthlyPerformanceStore.showLockDataBanner =
                            retVal.dataLockStatus;
                          message.success(
                            `${moment(
                              monthlyPerformanceStore.queryCriteria.startDate
                            ).format(
                              "MMM-YYYY"
                            )} Production records lock successfully`
                          );
                        } else {
                          message.info("select a valid production month");
                        }
                      } catch (error) {
                        notification.error({
                          message: "SPARS Feedback",
                          description: error.message,
                        });
                      }
                    },
                    onCancel() {
                      console.log("Cancel");
                    },
                  });
                },
              },
              {
                key: "spacere",
                onRender: () => <div style={{ width: "10px" }} />,
              },
              {
                key: "access",

                text: (
                  <Tooltip title="perform quick query on daily production using production dates">
                    Production Month Query
                  </Tooltip>
                ),

                onRenderIcon: () => <ZoomIn className="qicon" />,

                onClick: () => {
                  monthlyPerformanceStore.showSQeryDialog = true;
                },
              },
              {
                key: "spacer2",
                onRender: () => <div style={{ width: "10px" }} />,
              },

              {
                key: "search",
                onRender: () => (
                  <Tooltip title="smart quick search on the production data displayed">
                    <SearchBox
                      placeholder="Search"
                      styles={{
                        root: {
                          width: "100%",
                          borderBottomColor: "#CBD5E0",
                        },
                      }}
                      underlined={true}
                      onChange={(ev, searchTerms) => {
                        monthProdGrid.current.api.setQuickFilter(searchTerms);
                        // const filterValue = grid.current.api.filterManager.quickFilter;
                      }}
                    ></SearchBox>
                  </Tooltip>
                ),
              },
            ]}
            farItems={[
              {
                key: "Qr1",
                onClick: () => {
                  monthlyPerformanceStore.clearQuery();
                  monthlyPerformanceStore.showQueryDialog = true;
                },
                text: (
                  <Tooltip title="open query editor for monthly string productions">
                    &nbsp;SPARS Query Language Reporting(Editor)
                  </Tooltip>
                ),

                onRenderIcon: () => (
                  <ConsoleSqlOutlined
                    className="qicon"
                    style={{ marginLeft: "5px" }}
                  />
                ),

                ariaLabel: "New",
              },
              {
                key: "status",
                onRenderIcon: () => <UploadCloud className="qicon" />,
                text: (
                  <Tooltip title="shows upload timelines and status">
                    Upload Status
                  </Tooltip>
                ),
                onClick: async () => {
                  try {
                    monthlyPerformanceStore.showUploadStatusDialog = true;
                    await monthlyPerformanceStore.loadUploadStatus();
                    console.log([
                      ...monthlyPerformanceStore.uploadStatusItems.values(),
                    ]);
                  } catch (error) {
                    notification.error({
                      message: "SPARS Feedback",
                      description: error.message,
                    });
                  }
                },
              },
              {
                key: "repty",
                onRenderIcon: () => <FileText className="qicon" />,
                text: (
                  <Tooltip title="generate quick monthly Reports">
                    Reports
                  </Tooltip>
                ),
                subMenuProps: {
                  items: [
                    {
                      key: "prodsummary",
                      text: "Field Production Summary",
                      onClick: () => {
                        reportStore.reportParameters = {
                          ProdMonth: moment(
                            monthlyPerformanceStore.queryCriteria.startDate
                          ).month(),
                          ProdYear: moment(
                            monthlyPerformanceStore.queryCriteria.startDate
                          ).year(),
                        };
                        reportStore.reportName =
                          "QikReach.Reporting.Naoc.FieldProductionSummary,QikReach.Reporting";
                        reportStore.headerText =
                          "NAOC Field Production Summary";
                        reportStore.showReportDialog = true;
                      },
                    },

                    {
                      key: "FACILITYsummary",
                      text: "Flowstation Production Summary",
                      onClick: () => {
                        reportStore.reportParameters = {
                          ProdMonth: moment(
                            monthlyPerformanceStore.queryCriteria.startDate
                          ).month(),
                          ProdYear: moment(
                            monthlyPerformanceStore.queryCriteria.startDate
                          ).year(),
                        };
                        reportStore.reportName =
                          "QikReach.Reporting.Naoc.FacilityProductionSummary,QikReach.Reporting";
                        reportStore.headerText =
                          "NAOC Flowstation (facility) Production Summary";
                        reportStore.showReportDialog = true;
                      },
                    },
                  ],
                },
              },
              /* {
                key: "Qrq",
                disabled: monthlyPerformanceStore.prodHistory.length === 0,
                onRenderIcon: () => <BarChart2 className="qicon" />,
                text: (
                  <Tooltip title="generate quick visualization for Daily Oil Production Rythm,e.t.c">
                    Quick Visualization
                  </Tooltip>
                ),
                ariaLabel: "New",
                subMenuProps: {
                  items: [
                    {
                      key: "dopl1",
                      text: "Daily Oil Production Rythm",
                      iconProps: { iconName: "" },
                      onRenderIcon: () => <BarChart className="qicon" />,
                    },
                    {
                      key: "dopl2",
                      text: "Daily Gas Production Rythm",
                      iconProps: { iconName: "" },
                    },
                    {
                      key: "dopl4",
                      text: "Daily NGL Production Rythm",
                      iconProps: { iconName: "" },
                    },
                    {
                      key: "dopl6",
                      text: "Daily Fluid Production Rythm",
                      iconProps: { iconName: "" },
                      onRenderIcon: () => <BarChart className="qicon" />,
                    },
                    {
                      key: "das",
                      text: "Consumption/Production Ratio",
                      iconProps: { iconName: "" },
                      onRenderIcon: () => <PieChart className="qicon" />,
                    },
                  ],
                },
              }, */
              {
                key: "group4",
                disabled: monthlyPerformanceStore.prodHistory.length === 0,
                text: (
                  <Tooltip title="Export displayed production data to excel">
                    Export to Excel
                  </Tooltip>
                ),
                name: "group",
                onRenderIcon: () => <FileExcelOutlined className="qicon" />,

                onClick: async () => {
                  try {
                    monthlyPerformanceStore.isExporting = true;

                    await monthProdGrid.current.api.exportDataAsExcel({
                      sheetName: monthlyPerformanceStore.gridHeaderText.replace(
                        "NAOC PRODUCTION",
                        "NAOCPROD"
                      ),
                      allColumns: true,

                      skipFooters: false,

                      skipPinnedTop: false,
                      skipPinnedBottom: false,
                      fileName: "naoc_monthly_production_data",
                      skipColumnGroupHeaders: false,
                      skipColumnHeaders: false,
                      columnGroups: true,
                    });
                  } catch (error) {
                    notification.error({
                      message: "SPARS Feedback",
                      description: "export failed",
                    });
                  } finally {
                    monthlyPerformanceStore.isExporting = false;
                  }
                },
              },
            ]}
          />
        </div>
      </div>
      {monthlyPerformanceStore.showLockDataBanner && (
        <div className="ms-Grid" dir="ltr">
          <div className="ms-Grid-row">
            <div className="ms-Grid-col ms-sm12">
              <MessageBar messageBarType={MessageBarType.success}>
                <Lock size={18} color="green" />{" "}
                <span style={{ color: "green", fontWeight: "bold" }}>{`${moment(
                  monthlyPerformanceStore.queryCriteria.startDate
                ).format("MMM YYYY")} monthly productions has been Locked-In for
                  modifications and can only be viewed`}</span>
              </MessageBar>
            </div>
          </div>
        </div>
      )}

      {!monthlyPerformanceStore.showLockDataBanner &&
        monthlyPerformanceStore.prodHistory.length > 0 && (
          <div className="ms-Grid" dir="ltr">
            <div className="ms-Grid-row">
              <div className="ms-Grid-col ms-sm12">
                <MessageBar messageBarType={MessageBarType.warning}>
                  <ShieldOff size={18} color="red" />
                  {"  "}
                  <span style={{ color: "red", fontWeight: "bold" }}>
                    {`${moment(
                      monthlyPerformanceStore.queryCriteria.startDate
                    ).format(
                      "MMM YYYY"
                    )} monthly productions data has not been`}{" "}
                    {`locked-in and is opened to modifications!.`}
                  </span>
                  {"  "}
                  <div>
                    To prevent monthly productions data modifications,click the{" "}
                    <Lock size={18} /> <b>Lock-In Production</b> button
                  </div>
                </MessageBar>
              </div>
            </div>
          </div>
        )}

      {monthlyPerformanceStore.isLoading ? (
        <>
          <Skeleton active />
          <Skeleton active />
          <Skeleton active />
          <Skeleton active />
          <Skeleton active />
          <Skeleton active />
        </>
      ) : (
        <div
          className="ag-theme-balham"
          style={{
            minHeight: "50vh",
            height: "65vh",
            width: "100%",
            maxHeight: "80vh",
          }}
        >
          {monthlyPerformanceStore.prodHistory.length > 0 ? (
            <AgGridReact
              rowData={[...monthlyPerformanceStore.prodHistory.values()]}
              sideBar={["columns", "filters"]}
              ref={monthProdGrid}
              gridOptions={{
                defaultColDef: {
                  sortable: true,
                  filter: true,
                  enableValue: true,
                  enableRowGroup: true,
                  enablePivot: true,
                },
                enableCharts: true,
                enableRangeSelection: true,

                rowSelection: "single",
                pagination: true,
                columnDefs: gridcolumnDefs.columnDefs,
                animateRows: true,
                statusBar: {
                  statusPanels: [
                    {
                      statusPanel: "agTotalRowCountComponent",
                      align: "center",
                    },
                  ],
                },
                columnTypes: {
                  numberColumn: {
                    width: 130,
                    filter: "agNumberColumnFilter",
                  },
                  medalColumn: {
                    width: 100,
                    columnGroupShow: "open",
                    filter: false,
                  },
                  nonEditableColumn: { editable: false },
                  dateColumn: {
                    filter: "agDateColumnFilter",
                    filterParams: {
                      comparator: function (
                        filterLocalDateAtMidnight,
                        cellValue
                      ) {
                        var dateParts = cellValue.split("/");
                        var day = Number(dateParts[0]);
                        var month = Number(dateParts[1]) - 1;
                        var year = Number(dateParts[2]);
                        var cellDate = new Date(year, month, day);
                        if (cellDate < filterLocalDateAtMidnight) {
                          return -1;
                        } else if (cellDate > filterLocalDateAtMidnight) {
                          return 1;
                        } else {
                          return 0;
                        }
                      },
                    },
                  },
                },
              }}
              /*    onGridReady={(grid) => {
                const allColumnIds = [];
                grid.columnApi.getAllColumns().forEach(function (column) {
                  allColumnIds.push(column.colId);
                });

                grid.columnApi.autoSizeColumns(allColumnIds, false);
              }} */
              rowGroupPanelShow={"always"}
              rowSelection="multiple"
              onSelectionChanged={rowSelected}
              onSortChanged={sortChanged}
              copyHeadersToClipboard={true}
              overlayLoadingTemplate={`${(
                <span class="ag-overlay-loading-center">
                  Please wait while your rows are loading
                </span>
              )}`}
              overlayNoRowsTemplate={
                '<span style="padding: 10px; border: 2px solid #444; background: lightgoldenrodyellow;">No Result</span>'
              }
              pinnedBottomRowData={[
                {
                  oil: getTotal("oil"),
                  gas: getTotal("gas"),
                  water: getTotal("water"),
                },
              ]}
            ></AgGridReact>
          ) : monthlyPerformanceStore.monthlyProductions.size === 0 &&
            monthlyPerformanceStore.resultFromQuery === false ? (
            <div className="ms-Grid" dir="ltr" style={{}}>
              <div className="ms-Grid-row">
                <div
                  className="ms-Grid-col ms-sm12"
                  style={{
                    height: "500px",
                    display: "flex",
                    justifyContent: "center",
                    alignContent: "center",
                    flexDirection: "column",
                  }}
                >
                  <Empty
                    description={`No STRING Productions Upload for  ${moment(
                      monthlyPerformanceStore.queryCriteria.startDate
                    ).format("MMM YYYY")}`}
                  />
                  <div className="ms-Grid-row">
                    <div
                      className="ms-Grid-col ms-sm12"
                      style={{ textAlign: "center", paddingTop: "20px" }}
                    >
                      {" "}
                      <Button
                        type="danger"
                        icon={<UploadOutlined />}
                        onClick={() => {
                          monthlyPerformanceStore.resetWorkflow();
                        }}
                      >
                        Start STRING Production Upload
                      </Button>
                    </div>
                  </div>
                  <div className="ms-Grid-row">
                    <div
                      className="ms-Grid-col ms-sm12"
                      style={{ textAlign: "center", paddingTop: "10px" }}
                    >
                      OR
                    </div>
                    <div
                      className="ms-Grid-col ms-sm12"
                      style={{ textAlign: "center", paddingTop: "10px" }}
                    >
                      <Button
                        type="link"
                        icon={<ZoomInOutlined />}
                        onClick={() => {
                          monthlyPerformanceStore.showSQeryDialog = true;
                        }}
                      >
                        View previous monthly production upload
                      </Button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          ) : (
            <NoData
              title="No Productions Record Found"
              subTitle={`No NAOC Monthly Production Upload for  ${moment(
                monthlyPerformanceStore.queryCriteria.startDate
              ).format("MMM-YYYY")} `}
              clickHandler={refreshHandler}
            />
          )}
        </div>
      )}
    </>
  );
});

